import { ReactComponent as GuaSha } from '../../assets/images/enhancement/gua-sha.svg'
import { ReactComponent as LightTherapy } from '../../assets/images/enhancement/light-therapy.svg'
import { ReactComponent as ProfessionalPeel } from '../../assets/images/enhancement/professional-peel.svg'
import { ReactComponent as DiamondTip } from '../../assets/images/enhancement/diamond-tip.svg'
import { ReactComponent as HydrowandInfusion } from '../../assets/images/enhancement/hydrowand-infusion.svg'
import { ReactComponent as Microcurrent } from '../../assets/images/enhancement/microcurrent.svg'
import { ReactComponent as NanoInfusion } from '../../assets/images/enhancement/nano-infusion.svg'
import { ReactComponent as PlatinumParty } from '../../assets/images/enhancement/platinum-party.svg'
import { ReactComponent as Dermaplaning } from '../../assets/images/enhancement/dermaplaning.svg'
import { ReactComponent as SoothingScalp } from '../../assets/images/enhancement/soothing-scalp.svg'
import { ReactComponent as RadianceRenewal } from '../../assets/images/enhancement/radiance-renewal.svg'
import { ReactComponent as HolidayHydration } from '../../assets/images/enhancement/holiday-hydration.svg'
import { ReactComponent as BrighteningBoost } from '../../assets/images/enhancement/brightening-boost.svg'

export const enhancementIcons = [
  {
    icon: <SoothingScalp />,
    title: 'Soothing Scalp Revival',
    description:
      'An exclusive partnership with Briogeo, the clean scalp care experts. A soothing scalp oil treatment + stimulating massage paired with a hydrating jelly face mask with microcurrent.',
    order: 2,
  },
  {
    icon: <Dermaplaning />,
    title: 'Dermaplaning',
    description:
      'Next-level exfoliation for strikingly smooth skin. Dead skin and peach fuzz are removed, leaving skin radiant and more receptive to skincare ingredients.',
    newLabel: true,
    order: 1,
    addon: true,
  },
  {
    icon: <PlatinumParty />,
    title: 'Platinum Party',
    description:
      "We've paired a platinum-charged, illuminating face mask with hands-free microcurrent to keep you glowing all holiday season long.",
    helpText: 'Available through 12/31 or while supplies last.',
  },
  {
    icon: <NanoInfusion />,
    title: 'Nano Infusion',
    description:
      'Smooth fine lines & refine texture with this stimulating treatment for stressed or congested skin.',
  },
  {
    icon: <DiamondTip />,
    title: 'Diamond Tip Microdermabrasion',
    description:
      'This hybrid exfoliation uses diamonds to rejuvenate congested skin, brighten dullness & even tone.',
    newLabel: false,
  },
  {
    icon: <HydrowandInfusion />,
    title: 'Hydro Wand Infusion',
    description:
      'Focus on specific areas with this infusion wand, delivering potent formulas & maximum hydration.',
    newLabel: false,
  },
  {
    icon: <Microcurrent />,
    title: 'Microcurrent',
    description:
      'Lift, tone & instantly glow with this electric treatment, designed to promote circulation & collagen production.',
    newLabel: false,
  },
  {
    icon: <ProfessionalPeel />,
    title: 'Professional Peel',
    description:
      'Tackle hyperpigmentation, breakouts & fine lines with a made-for-you chemical exfoliation.',
    newLabel: false,
  },
  {
    icon: <LightTherapy />,
    title: 'Light Therapy',
    titleVisible: 'LED Light Therapy',
    description:
      'Reduce the appearance of fine lines & calm inflammation with restorative red light therapy.',
    newLabel: false,
  },
  {
    icon: <GuaSha />,
    title: 'Gua Sha',
    description:
      'This ancient Chinese massage technique encourages lymphatic flow to tone, detoxify & lift skin.',
    newLabel: false,
  },
  {
    icon: <RadianceRenewal />,
    title: 'Radiance Renewal',
    description:
      'This trifecta of LED Light Therapy, Microcurrent, and a Jelly Mask combine to repair, rebuild & refresh your skin just in time for cooler weather.',
    newLabel: true,
    newLabelText: 'AVAIL THRU NOV 11*',
    helpText: 'Available through 11/11 or while supplies last.',
  },
  {
    icon: <HolidayHydration />,
    title: 'Holiday Hydration Boost',
    description:
      'Our Holiday Hydration Boost provides the ultimate support for the winter season. Melt into an Intensive Recovery jelly mask, self-warming eye mask + LED Light Therapy.',
    newLabel: true,
    newLabelText: 'LIMITED TIME ONLY',
  },
  {
    icon: <BrighteningBoost />,
    title: 'Brightening Boost',
    description:
      'Our Brightening Boost pairs Nano Infusion with IMAGE MD® Restoring Power-C Serum plus LED Light Therapy for a natural burst of benefits. Start your new year bright.',
    newLabel: true,
    newLabelText: 'LIMITED TIME ONLY',
    borderColor: '#F2B14E',
  },
]
